import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { consumeTheme } from '../../utils/theme';
import { A11yClickable } from '../../utils/a11yClickable';
var Tag = (function (_super) {
    __extends(Tag, _super);
    function Tag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, clickable = _b.clickable, onClick = _b.onClick, rest = __rest(_b, ["prefixCls", "className", "style", "children", "clickable", "onClick"]);
            var cls = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-clickable"] = clickable,
                _a));
            return (h(A11yClickable, { onClick: onClick },
                h("div", __assign({ className: cls, style: style }, rest), children)));
        };
        return _this;
    }
    Tag.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Tag;
}(React.Component));
export default Tag;
Tag.defaultProps = {
    prefixCls: 'dui-tag',
    clickable: true
};
Tag.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    clickable: PropTypes.bool
};
